declare const require: (path: string) => string;

export const gallerySlides = [
  {
    imageSource:  require("../static/images/gallery/1x/gallery01.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery01.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery02.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery02.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery03.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery03.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery04.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery04.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery05.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery05.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery06.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery06.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery07.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery07.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery08.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery08.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery09.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery09.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery010.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery010.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery011.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery011.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery012.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery012.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery013.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery013.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery014.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery014.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery015.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery015.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery016.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery016.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery017.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery017.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery018.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery018.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery019.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery019.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery020.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery020.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery021.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery021.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery022.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery022.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery023.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery023.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery024.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery024.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery025.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery025.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery026.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery026.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery027.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery027.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery028.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery028.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery029.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery029.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery030.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery030.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery031.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery031.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery032.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery032.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery033.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery033.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery034.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery034.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery035.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery035.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery036.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery036.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery037.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery037.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery038.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery038.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery039.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery039.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery040.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery040.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery041.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery041.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery042.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery042.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery043.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery043.jpg")
  },
  {
    imageSource:  require("../static/images/gallery/1x/gallery044.jpg"),
    imageSourceX2:  require("../static/images/gallery/2x/gallery044.jpg")
  },
];